import React from 'react';
import { Toolbar, ToolbarTitle } from 'material-ui/Toolbar';
import { Card, CardHeader } from 'material-ui/Card';
import COLORS from '../../../theme/colors';

import './contact_us.scss';

export default function ContactUs() {
  return (
    <div
      id="contact-us-section"
      name="contact-us-section"
      className="contact-us"
    >
      <Toolbar style={{ backgroundColor: COLORS.purple }}>
        <ToolbarTitle
          text="Contact Us"
          style={{ color: COLORS.white }}
        />
      </Toolbar>
      <div className="content">
        <Card className="card">
          <CardHeader
            title={
              <span>
                If you don’t find an answer to your question here, contact us at <a href="mailto:support@teamhub.tv">support@teamhub.tv</a> and we will be happy to help.
              </span>
            }
            titleColor={COLORS.purple}
          />
        </Card>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/faq/contact_us/contact_us.jsx